import styles from "@shared/components/chat/Messages.module.scss"

import React, { memo } from "react"

import { ChatDownIcon, PowerfulMessage } from "@shared/components"
import {
  useLayerPopupContext,
  useMessagesContext,
  useSchedule,
} from "@shared/contexts"
import { useCheckNewMessage, useMessagesRef } from "@shared/hooks"

import classNames from "classnames"

export default memo(function Messages() {
  const { schedule } = useSchedule()
  const { font } = useLayerPopupContext()
  const { messages, managerMessages } = useMessagesContext()
  const chatHistoryMessages = schedule?.isChatEnabled ? messages : managerMessages

  useCheckNewMessage({
    messages: chatHistoryMessages,
    isUser: true,
    isActive: true,
  })

  const { messagesRef, handleScroll: scrollMessages } = useMessagesRef({
    messages: chatHistoryMessages,
    noticeHeight: 5,
  })

  const scheduleId = schedule?.id

  return (
    <div className={classNames("chatB", styles.active)}>
      <div
        className={classNames("inner", styles[font.size])}
        ref={messagesRef}
        style={{
          paddingTop: 5,
        }}
      >
        {chatHistoryMessages.map((message) => (
          <PowerfulMessage
            key={message.key}
            scrollMessages={scrollMessages}
            message={message}
            isNicknameStyled={false}
            showBlindButton={false}
            scheduleId={scheduleId}
          />
        ))}
        <ChatDownIcon messagesRef={messagesRef} />
      </div>
    </div>
  )
})
